<div class="resp-container">
    <iframe *ngIf="safeUrl" class="resp-iframe" [src]="safeUrl"></iframe>
</div>
